import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BankLinesListItemContentWrapper = styled.div`
  width: 100%;
  min-width: 0;
  contain: inline-size;
`

/* Hack for truncating text within flex container */
export const BankLinesListItemDetails = styled.div`
  flex: 1;
  min-width: 0;
  margin-right: ${Spacing.S16};
`

export const BankLinesListItemAmount = styled.div`
  flex-shrink: 0;
`
